/* Fireplace universal-template presentation only. Keep the original variant,
   quantity, availability, form, cart and checkout handlers authoritative. */
(function () {
  'use strict';
  function boot() {
    // This asset is loaded only by the authorized fireplace/electric collection gate.
    var page = document.querySelector('.ef-uni-page');
    var form = page && page.querySelector('form#efUniForm');
    var config = form && form.querySelector('.ef-uni-config');
    var buy = form && form.querySelector('.ef-uni-buy-row');
    var atc = form && form.querySelector('#efUniATC');
    if (!page || !form || !config || !buy || !atc || form.dataset.efSimpleNative) return;
    form.dataset.efSimpleNative = 'fireplaces-v1';
    page.classList.add('ef-simple-native');
    function el(tag, cls, text) {
      var node = document.createElement(tag); node.className = cls;
      if (text) node.textContent = text; return node;
    }
    function copy(node, text) { if (node && node.textContent !== text) node.textContent = text; }
    function stage(id, title, hint) {
      var node = el('section', 'ef-simple-native__stage'); node.id = id;
      var heading = el('h3', 'ef-simple-native__heading', title); heading.tabIndex = -1;
      node.append(heading, el('p', 'ef-simple-native__hint', hint)); return node;
    }
    var groups = Array.from(form.querySelectorAll('.ef-uni-variant-group'));
    var titleNode = page.querySelector('h1');
    var model = titleNode ? titleNode.textContent.trim() : 'Your model';
    var one = stage('ef-native-options', groups.length ? '1. Choose your options' : '1. Your model', groups.length ? 'Choose the options for this model. The price updates with your selections.' : 'Review this model and its product details.');
    if (!groups.length) one.append(el('p', 'ef-simple-native__model', model));
    config.prepend(one);
    var two = stage('ef-native-equipment', '2. Equipment & details', 'Review the product details and manufacturer documents for included items, compatibility and any additional requirements.');
    buy.before(two);
    var three = stage('ef-native-review', '3. Review your selections', 'Check your model, options and quantity before adding to cart.');
    var review = el('div', 'ef-simple-native__review'); three.append(review);
    three.append(el('p', 'ef-simple-native__hint', 'Installation is not included. Any applicable tax and delivery charges are shown at checkout.'));
    buy.before(three);
    var nav = el('nav', 'ef-simple-native__nav'); nav.setAttribute('aria-label', 'Your order');
    [[one, 'Options'], [two, 'Equipment'], [three, 'Review']].forEach(function (entry, index) {
      var link = el('a', '', (index + 1) + '. ' + entry[1]); link.href = '#' + entry[0].id;
      link.addEventListener('click', function (event) { event.preventDefault(); entry[0].querySelector('h3').focus({ preventScroll: true }); entry[0].scrollIntoView({ block: 'start' }); }); nav.append(link);
    });
    var help = page.querySelector('#ef-family-help');
    if (help) {
      var helpLink = el('a', 'ef-simple-native__help', 'Not sure? Talk to a specialist'); helpLink.href = '#ef-family-help';
      helpLink.addEventListener('click', function (event) { event.preventDefault(); help.scrollIntoView({ block: 'start' }); var target = help.querySelector('a'); if (target) target.focus({ preventScroll: true }); });
      nav.append(helpLink);
    }
    config.prepend(nav);
    var formTitle = form.parentElement.querySelector('.ef-family-form-title');
    copy(formTitle, groups.length ? 'Choose your options' : 'Your order');
    var expert = page.querySelector('.ef-fireplace-early-help');
    var box = form.closest('.efx-pdp__buybox');
    if (expert && box) box.after(expert);
    function visible(node) {
      for (var n = node; n && n !== form; n = n.parentElement) if (n.hidden || getComputedStyle(n).display === 'none') return false;
      return true;
    }
    function edit(target) {
      var ancestor = target.parentElement.closest('details');
      while (ancestor && form.contains(ancestor)) { ancestor.open = true; ancestor = ancestor.parentElement.closest('details'); }
      var control = target.matches('input,select,button') ? target : target.querySelector('.ef-uni-dropdown__trigger, [data-variant-option][aria-checked="true"], select, [data-variant-option]:not([disabled]), input');
      if (control) control.focus({ preventScroll: true }); target.scrollIntoView({ block: 'center' });
    }
    var signature = null;
    function update() {
      var rows = [{ label: 'Model', value: model, target: null }];
      Array.from(form.querySelectorAll('.ef-uni-variant-group')).filter(visible).forEach(function (group) {
        var selected = group.querySelector('[data-variant-option][aria-checked="true"]');
        var select = group.querySelector('select');
        var display = group.querySelector('[data-selected-display]');
        rows.push({ label: group.dataset.axisName || 'Option', value: selected ? selected.dataset.variantOption : select ? select.value : display ? display.textContent.trim() : 'Choose an option', target: group });
      });
      var qty = form.querySelector('input[name="quantity"]');
      if (qty) rows.push({ label: 'Quantity', value: qty.value || 'Enter quantity', target: qty });
      var next = JSON.stringify(rows.map(function (row) { return [row.label, row.value]; }));
      if (next === signature) return;
      signature = next; review.replaceChildren();
      rows.forEach(function (row) {
        var item = el('div', 'ef-simple-native__row');
        var words = el('div', ''); words.append(el('span', 'ef-simple-native__label', row.label), el('strong', '', row.value)); item.append(words);
        if (row.target) {
          var button = el('button', 'ef-simple-native__edit', 'Edit'); button.type = 'button'; button.setAttribute('aria-label', 'Edit ' + row.label);
          button.addEventListener('click', function () { edit(row.target); }); item.append(button);
        }
        review.append(item);
      });
    }
    var queued = false;
    function schedule() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; update(); }); }
    form.addEventListener('input', schedule);
    form.addEventListener('change', schedule);
    form.addEventListener('click', schedule);
    new MutationObserver(schedule).observe(form, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['aria-checked', 'value', 'hidden', 'style'] });
    update();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
